export const CONSTRUCTOR_SECTIONS = {
  PRODUCTS: "Products",
  SEARCH_SUGGESTIONS: "Search Suggestions",
  COLLECTIONS: "Collections",
  BRANDS: "Brands",
  CATEGORIES: "Categories",
} as const;
